<script lang="ts">
  import AddMilestoneButton from "./MilestoneEditor/AddMilestoneButton.svelte"
  import { Milestone } from "@models/milestones/Milestone"
  import { Package } from "@models/trips/Package"
  import MilestoneForm from "./MilestoneEditor/MilestoneForm.svelte"
  import MilestonePreview from "./MilestoneEditor/MilestonePreview.svelte"
  export let milestones: Milestone[]
  export let packages: Package[]
  export let tripId: number
  export let registrationClosesOn: string
  export let readOnly: false

  function milestonePath(milestone) {
    if (milestone.id) {
      return `/api/v1/trips/${milestone.tripId}/milestone_dates/${milestone.id}`
    } else {
      return `/api/v1/trips/${milestone.tripId}/milestone_dates/`
    }
  }
</script>

<div class="fake-table-component border-gray-200">
  {#if milestones.length <= 1 && !readOnly}
    <AddMilestoneButton bind:milestones {tripId} />
  {/if}
  {#each milestones as milestone, index}
    <div>
      {#if milestone.isEditing}
        <MilestoneForm bind:milestones bind:milestone {registrationClosesOn} path={milestonePath(milestone)} />
      {:else}
        <MilestonePreview bind:milestones bind:milestone {packages} path={milestonePath(milestone)} {readOnly} />
      {/if}
    </div>

    {#if milestones.length === index + 2 && !readOnly}
      <AddMilestoneButton bind:milestones {tripId} />
    {/if}
  {/each}
</div>
